import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  margin-right: 10px;
`;

export const IconWrapperMini = styled.div`
  display: inline-block;
  width: 15px;
  height: 15px;
  position: relative;
  margin-right: 10px;
  svg {
    width: 15px;
    height: 15px;
  }
`;

export const GraphWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const IconWrapperBig = styled.div`
  display: inline-block;
  position: relative;
  margin-right: 10px;
  svg {
    max-width: 27px;
    max-height: 27px;
  }
`;
